import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pr0040',
    ecrans: ['00-2']
});
